import React from "react";

function SectionContainer({
  children,
  background = "#fff"
}) {
  return (
    <section
      style={{
        padding: "90px 20px",
        background
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto"
        }}
      >
        {children}
      </div>
    </section>
  );
}

export default SectionContainer;